(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovrze_upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ovrze-upsell]';

    function safeJson(text, fallback) {
      try {
        return JSON.parse(text || '');
      } catch (error) {
        return fallback;
      }
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function sizeIndex(optionNames) {
      return optionNames.findIndex((name) => {
        const normalized = normalize(name);
        return normalized === 'size' || normalized === 'größe' || normalized === 'groesse';
      });
    }

    function initUpsell(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('.ovrze-upsell__dialog');
      const closeButtons = root.querySelectorAll('[data-ovrze-close]');
      const triggerDelay = Number(root.dataset.triggerDelay || 900);
      const oncePerSession = root.dataset.oncePerSession === 'true';
      const afterAdd = root.dataset.afterAdd || 'cart_page';
      const sectionId = root.dataset.sectionId || 'default';
      const storageKey = `ovrze-upsell-shown-${sectionId}`;
      const currentVariants = safeJson(root.querySelector('[data-ovrze-current-variants]')?.textContent, []);
      const currentOptionNames = safeJson(root.querySelector('[data-ovrze-current-options]')?.textContent, []);
      const currentVariantIds = new Set(currentVariants.map((variant) => String(variant.id)));
      let lastFocused = null;
      let openTimer = null;
      let submittedVariantId = null;

      if (!root.querySelector('[data-ovrze-card]')) return;

      function alreadyShown() {
        if (!oncePerSession) return false;
        try {
          return sessionStorage.getItem(storageKey) === '1';
        } catch (error) {
          return false;
        }
      }

      function markShown() {
        if (!oncePerSession) return;
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (error) {
          // Session storage can be unavailable; the offer still works.
        }
      }

      function closeNativeCartUI() {
        const horizonDrawer = document.querySelector('#cart-drawer');
        if (horizonDrawer && typeof horizonDrawer.close === 'function') {
          try { horizonDrawer.close(); } catch (error) {}
        }

        const genericDrawer = document.querySelector('cart-drawer');
        if (genericDrawer && typeof genericDrawer.close === 'function') {
          try { genericDrawer.close(); } catch (error) {}
        }

        document.querySelectorAll('dialog[open]').forEach((openDialog) => {
          if (openDialog.closest('[data-ovrze-upsell]')) return;
          if (typeof openDialog.close === 'function') {
            try { openDialog.close(); } catch (error) {}
          }
        });
      }

      function matchSubmittedSize() {
        if (!submittedVariantId) return;
        const sourceVariant = currentVariants.find((variant) => String(variant.id) === String(submittedVariantId));
        const sourceSizeIndex = sizeIndex(currentOptionNames);
        if (!sourceVariant || sourceSizeIndex < 0) return;

        const sourceSize = sourceVariant.options?.[sourceSizeIndex];
        if (!sourceSize) return;

        root.querySelectorAll('[data-ovrze-card]').forEach((card) => {
          const optionNames = safeJson(card.dataset.optionNames, []);
          const targetSizeIndex = sizeIndex(optionNames);
          const select = card.querySelector('[data-ovrze-variant]');
          if (!select || targetSizeIndex < 0) return;

          const matchingOption = Array.from(select.options).find((option) => {
            const options = safeJson(option.dataset.options, []);
            return normalize(options[targetSizeIndex]) === normalize(sourceSize);
          });

          if (matchingOption) {
            select.value = matchingOption.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      function openPopup() {
        if (root.classList.contains('is-open') || alreadyShown()) return;
        closeNativeCartUI();
        matchSubmittedSize();
        lastFocused = document.activeElement;
        root.classList.add('is-open');
        document.body.classList.add('ovrze-upsell-lock');
        markShown();
        window.setTimeout(() => dialog?.focus(), 30);
      }

      function closePopup() {
        root.classList.remove('is-open');
        document.body.classList.remove('ovrze-upsell-lock');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      closeButtons.forEach((button) => button.addEventListener('click', closePopup));

      document.addEventListener('keydown', (event) => {
        if (!root.classList.contains('is-open')) return;
        if (event.key === 'Escape') closePopup();

        if (event.key === 'Tab' && dialog) {
          const focusable = dialog.querySelectorAll(
            'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });

      function scheduleOpen() {
        if (alreadyShown()) return;
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(openPopup, triggerDelay);
      }

      document.addEventListener(
        'submit',
        (event) => {
          const form = event.target.closest('form[action*="/cart/add"]');
          if (!form) return;

          const data = new FormData(form);
          const variantId = data.get('id');
          const productId = data.get('product-id');
          const isCurrentProduct =
            (variantId && currentVariantIds.has(String(variantId))) ||
            (productId && String(productId) === String(root.dataset.currentProductId));

          if (!isCurrentProduct) return;
          submittedVariantId = variantId ? String(variantId) : submittedVariantId;
          scheduleOpen();
        },
        true
      );

      document.addEventListener(
        'click',
        (event) => {
          const stickyButton = event.target.closest('sticky-add-to-cart .add-to-cart-button');
          if (!stickyButton) return;

          const stickyRoot = stickyButton.closest('sticky-add-to-cart');
          const variantId = stickyRoot?.dataset.currentVariantId;
          if (variantId && currentVariantIds.has(String(variantId))) {
            submittedVariantId = String(variantId);
          }
          scheduleOpen();
        },
        true
      );

      if (window.Shopify && window.Shopify.designMode && root.dataset.previewEditor === 'true') {
        window.setTimeout(openPopup, 350);
      }

      root.querySelectorAll('[data-ovrze-card]').forEach((card) => {
        const variantSelect = card.querySelector('[data-ovrze-variant]');
        const originalPrice = card.querySelector('[data-ovrze-original-price]');
        const salePrice = card.querySelector('[data-ovrze-sale-price]');
        const savings = card.querySelector('[data-ovrze-save]');
        const addButton = card.querySelector('[data-ovrze-add]');
        const addLabel = card.querySelector('[data-ovrze-add-label]');
        const status = card.querySelector('[data-ovrze-status]');
        const initialButtonText = addLabel?.textContent || 'Hinzufügen';

        function updatePricePreview() {
          const option = variantSelect?.selectedOptions?.[0];
          if (!option) return;
          if (originalPrice) originalPrice.textContent = option.dataset.originalPrice || '';
          if (salePrice) salePrice.textContent = option.dataset.salePrice || '';
          if (savings) savings.textContent = `Spare ${option.dataset.savings || ''}`;
        }

        variantSelect?.addEventListener('change', updatePricePreview);
        updatePricePreview();

        addButton?.addEventListener('click', async () => {
          const variantId = variantSelect?.value;
          if (!variantId || addButton.disabled) return;

          addButton.disabled = true;
          addButton.classList.add('is-loading');
          if (status) {
            status.textContent = '';
            status.classList.remove('is-error');
          }

          try {
            const base = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${base}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: 1 }],
              }),
            });

            if (!response.ok) {
              let message = 'Der Artikel konnte nicht hinzugefügt werden.';
              try {
                const errorData = await response.json();
                message = errorData.description || errorData.message || message;
              } catch (error) {}
              throw new Error(message);
            }

            if (addLabel) addLabel.textContent = 'Hinzugefügt ✓';
            if (status) status.textContent = 'Dein zweites Piece ist im Warenkorb.';

            document.dispatchEvent(
              new CustomEvent('ovrze:upsell-added', {
                bubbles: true,
                detail: { variantId: Number(variantId) },
              })
            );

            if (afterAdd === 'cart_page') {
              window.setTimeout(() => {
                window.location.href = `${base}cart`;
              }, 380);
            } else {
              window.setTimeout(() => {
                closePopup();
                addButton.disabled = false;
                addButton.classList.remove('is-loading');
                if (addLabel) addLabel.textContent = initialButtonText;
              }, 900);
            }
          } catch (error) {
            if (status) {
              status.textContent = error.message || 'Der Artikel konnte nicht hinzugefügt werden.';
              status.classList.add('is-error');
            }
            addButton.disabled = false;
            addButton.classList.remove('is-loading');
          }
        });
      });
    }

    function initAll(scope = document) {
      scope.querySelectorAll(SELECTOR).forEach(initUpsell);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
